module.exports = __webpack_public_path__ + "img/partner-hover2.3c3dfb80.png";